import React from "react";
import AuthPage from "../components/Auth/AuthPage";

function AuthPreview() {
  const handleLogin = (user) => {
    console.log("✅ Login successful:", user);
    // Navigate to main app after successful login
    window.location.href = "/";
  };

  return <AuthPage onLogin={handleLogin} />;
}

export default AuthPreview;
